import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { ProductContext } from "../context/AppContext";
import { Button, Card, Pagination, InputGroup, FormControl, Modal, Badge, Form, Spinner, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import {
    FaEnvelope,
    FaSms,
    FaCalendar,
    FaSearch,
    FaSync,
    FaEye,
    FaDownload,
    FaFilter,
    FaPhone,
    FaUser,
    FaHistory,
    FaChartBar,
    FaList,
    FaTimes,
    FaCheck,
    FaClock,
    FaIdCard,
    FaSchool,
    FaFileAlt,
    FaExclamationTriangle,
    FaInfoCircle,
    FaExclamation
} from "react-icons/fa";
import { all_routes } from "./router/all_routes";
import Header from "./Header";


function ResendPasswordHistory() {
     const { allClass = [], GetstudentData } = useContext(ProductContext);
     const location = useLocation();
    const routes = all_routes;
console.log(GetstudentData?.contact_phone, 'phone1')
console.log(GetstudentData?.contact_email, 'phone2')
//     useEffect(() => {
//   if (location.state?.activeTab) {
//     setActiveTab(location.state.activeTab);

//     const today = moment().format("YYYY-MM-DD");

//     if (location.state.activeTab === "sms") {
//       setSearchQuery(location.state.phone || "");
//       fetchSMSHistory({
//         phone: phoneNumber,
//         start_date: today,
//         end_date: today,
//       });
//     }

//     if (location.state.activeTab === "email") {
//       setSearchQuery(location.state.email || "");
//       fetchEmailHistory({
//         email: location.state.email,
//         start_date: today,
//         end_date: today,
//       });
//     }
//   }
// }, [location.state]);

    const [activeTab, setActiveTab] = useState("sms");
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [selectedClass, setSelectedClass] = useState(null);
    const [smsHistory, setSmsHistory] = useState([]);
    const [emailHistory, setEmailHistory] = useState([]);
    const [filteredSmsHistory, setFilteredSmsHistory] = useState([]);
    const [filteredEmailHistory, setFilteredEmailHistory] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [expandedRows, setExpandedRows] = useState([]);
    const authtoken = localStorage.getItem("token");

    const classOptions = allClass?.map((cls) => ({
        value: cls.id,
        label: cls.Classes,
    })) || [];

    console.log(filteredSmsHistory, "filteredSmsHistory Data");
    console.log(filteredEmailHistory, "filteredSmsHistory Data2");
    // Current data based on active tab
    const currentData = activeTab === "sms" ? filteredSmsHistory : filteredEmailHistory;
    const totalItems = currentData.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentItems = currentData.slice(startIndex, startIndex + itemsPerPage);

    // Summary statistics
    const summary = {
        totalSMS: smsHistory.length,
        totalEmails: emailHistory.length,
        totalMessages: smsHistory.length + emailHistory.length
    };

    const summaryCardsData = [
        {
            title: "Total SMS",
            subtitle: "All SMS records",
            value: summary.totalSMS,
            icon: <FaSms />,
            bg: "#efe7ff",
            iconColor: "#7b3fe4",
        },
        {
            title: "Total Emails",
            subtitle: "All email records",
            value: summary.totalEmails,
            icon: <FaEnvelope />,
            bg: "#fff3d6",
            iconColor: "#f08c00",
        },
        {
            title: "Total Messages",
            subtitle: "All communications",
            value: summary.totalMessages,
            icon: <FaChartBar />,
            bg: "#ffe3d8",
            iconColor: "#e8590c",
        },
        {
            title: "Quick Actions",
            subtitle: "Refresh or download",
            icon: <FaSync />,
            bg: "#e6fbf0",
            iconColor: "#0c8a58",
            isActions: true,
        },
    ];


const phoneNumber = GetstudentData?.contact_phone || null;
const emailContact = GetstudentData?.contact_email || null;
const initialTab = location.state?.activeTab || "sms";

    // Fetch SMS History with filters
    const fetchSMSHistory = async (filters = {}) => {
  if (!filters.phone) {
    setFilteredSmsHistory([]);
    return;
  }

  setIsLoading(true);
  try {
    const params = new URLSearchParams(filters);

    const response = await fetch(
      `https://api.mirai.healthcare/api/exam/sms-history?${params.toString()}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth": authtoken,
        },
      }
    );

            const data = await response.json();
            if (data.success && data.message?.exam) {
                const transformed = data.message.exam.map((item, index) => ({
                    key: item.id || index,
                    id: item.id,
                    type: "SMS",
                    phone: item.phone,
                    email: "-",
                    message: item.message,
                    subject: "-",
                    created_at: item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm") : "N/A",
                    created_at_raw: item.created_at,
                    status: "sent",
                    message_length: item.message?.length || 0,
                    is_expired: moment(item.created_at).isBefore(moment().subtract(30, 'days'))
                }));
                setSmsHistory(transformed);
                setFilteredSmsHistory(transformed);
            } else {
                setSmsHistory([]);
                setFilteredSmsHistory([]);
            }
        } catch (error) {
            console.error("Fetch SMS history error:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch SMS history.",
            });
            setSmsHistory([]);
            setFilteredSmsHistory([]);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchEmailHistory = async (filters = {}) => {
  if (!filters.email) {
    setFilteredEmailHistory([]);
    return;
  }

  setIsLoading(true);
  try {
    const params = new URLSearchParams(filters);

    const response = await fetch(
      `https://api.mirai.healthcare/api/exam/email-history?${params.toString()}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth": authtoken,
        },
      }
    );

            const data = await response.json();
            if (data.success && data.message?.exam) {
                const transformed = data.message.exam.map((item, index) => ({
                    key: item.id || index,
                    id: item.id,
                    type: "Email",
                    phone: "-",
                    email: item.email,
                    message: item.message,
                    subject: item.subject,
                    created_at: item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm") : "N/A",
                    created_at_raw: item.created_at,
                    status: "sent",
                    message_length: item.message?.length || 0,
                    is_expired: moment(item.created_at).isBefore(moment().subtract(30, 'days'))
                }));
                setEmailHistory(transformed);
                setFilteredEmailHistory(transformed);
            } else {
                setEmailHistory([]);
                setFilteredEmailHistory([]);
            }
        } catch (error) {
            console.error("Fetch email history error:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch email history.",
            });
            setEmailHistory([]);
            setFilteredEmailHistory([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
  setActiveTab(initialTab);

  const today = moment().format("YYYY-MM-DD");

  // 👉 SMS
  if (initialTab === "sms") {
    if (!phoneNumber) {
      setFilteredSmsHistory([]);
      return;
    }

    fetchSMSHistory({
      phone: phoneNumber,
      start_date: today,
      end_date: today,
    });
  }

  // 👉 Email
  if (initialTab === "email") {
    if (!emailContact) {
      setFilteredEmailHistory([]);
      return;
    }

    fetchEmailHistory({
      email: emailContact,
      start_date: today,
      end_date: today,
    });
  }
}, [initialTab, phoneNumber, emailContact]);

    // Handle search with API filtering
    // const handleSearch = () => {
    //     setCurrentPage(1);

    //     const filters = {
    //         start_date: startDate,
    //         end_date: endDate
    //     };

    //     if (activeTab === "sms") {
    //         fetchSMSHistory(filters);
    //     } else {
    //         fetchEmailHistory(filters);
    //     }
    // };

    const handleSearch = () => {
  setCurrentPage(1);

  const filters = {
    start_date: startDate,
    end_date: endDate,
  };

  if (activeTab === "sms") {
    if (!phoneNumber) return;
    fetchSMSHistory({
      ...filters,
      phone: phoneNumber,   // 🔥 REQUIRED
    });
  } else {
    if (!emailContact) return;
    fetchEmailHistory({
      ...filters,
      email: emailContact,  // 🔥 REQUIRED
    });
  }
};

    // Handle tab change with API call
    // const handleTabClick = (tab) => {
    //     setActiveTab(tab);
    //     setSearchQuery("");
    //     setCurrentPage(1);
    //     setExpandedRows([]);

    //     // Fetch data for the selected tab with current date filters
    //     const filters = {
    //         start_date: startDate,
    //         end_date: endDate
    //     };

    //     if (tab === "sms") {
    //         fetchSMSHistory(filters);
    //     } else {
    //         fetchEmailHistory(filters);
    //     }
    // };

    const handleTabClick = (tab) => {
  setActiveTab(tab);
  setCurrentPage(1);

  const today = moment().format("YYYY-MM-DD");

  if (tab === "sms") {
    if (!phoneNumber) {
      setFilteredSmsHistory([]);
      return;
    }
    fetchSMSHistory({ phone: phoneNumber, start_date: today, end_date: today });
  }

  if (tab === "email") {
    if (!emailContact) {
      setFilteredEmailHistory([]);
      return;
    }
    fetchEmailHistory({ email: emailContact, start_date: today, end_date: today });
  }
};

    // Reset filters and fetch all data for current date
    // const resetFilters = () => {
    //     setSearchQuery("");
    //     setStartDate(moment().format("YYYY-MM-DD"));
    //     setEndDate(moment().format("YYYY-MM-DD"));
    //     setSelectedClass(null);
    //     setCurrentPage(1);
    //     setExpandedRows([]);

    //     // Fetch data with current date
    //     const filters = {
    //         start_date: moment().format("YYYY-MM-DD"),
    //         end_date: moment().format("YYYY-MM-DD")
    //     };

    //     if (activeTab === "sms") {
    //         fetchSMSHistory(filters);
    //     } else {
    //         fetchEmailHistory(filters);
    //     }
    // };

    const resetFilters = () => {
  const today = moment().format("YYYY-MM-DD");

  setStartDate(today);
  setEndDate(today);
  setCurrentPage(1);
  setExpandedRows([]);

  if (activeTab === "sms") {
    if (!phoneNumber) return;
    fetchSMSHistory({
      phone: phoneNumber,   // 🔥 REQUIRED
      start_date: today,
      end_date: today,
    });
  } else {
    if (!emailContact) return;
    fetchEmailHistory({
      email: emailContact,  // 🔥 REQUIRED
      start_date: today,
      end_date: today,
    });
  }
};

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            setExpandedRows([]);
        }
    };

    const viewDetails = (record) => {
        setSelectedRecord(record);
        setShowDetailsModal(true);
    };

    const handleToggleRow = (recordId) => {
        setExpandedRows((prev) =>
            prev.includes(recordId) ? prev.filter((id) => id !== recordId) : [...prev, recordId]
        );
    };

    const downloadHistory = () => {
        if (currentData.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "No Data",
                text: "No data available to download.",
            });
            return;
        }

        const headers = activeTab === "sms"
            ? ['ID', 'Phone', 'Message', 'Message Length', 'Sent Date', 'Status']
            : ['ID', 'Email', 'Subject', 'Message', 'Message Length', 'Sent Date', 'Status'];

        const csvRows = currentData.map((item) =>
            activeTab === "sms"
                ? [item.id, item.phone, `"${item.message}"`, item.message_length, item.created_at, item.status]
                : [item.id, item.email, `"${item.subject}"`, `"${item.message}"`, item.message_length, item.created_at, item.status]
        );

        const csvContent = [
            headers.join(','),
            ...csvRows.map(row => row.join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `${activeTab}_history_${moment().format('YYYY-MM-DD')}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        Swal.fire({
            icon: "success",
            title: "Downloaded",
            text: "CSV file downloaded successfully.",
        });
    };

    // Helper function for pagination visibility
    function getVisiblePages(current, total) {
        const pages = [];
        if (total <= 7) {
            for (let i = 1; i <= total; i++) pages.push(i);
        } else {
            pages.push(1);
            if (current > 4) pages.push("...");
            for (let i = Math.max(2, current - 2); i <= Math.min(total - 1, current + 2); i++) {
                pages.push(i);
            }
            if (current < total - 3) pages.push("...");
            pages.push(total);
        }
        return pages;
    }

    const renderCardActions = (item) => {
        return (
            <div className="card-actions">
                <div className="d-flex flex-wrap gap-2 align-items-center justify-content-end">
                    <button
                        type="button"
                        className="btn btn-outline-info btn-sm"
                        onClick={() => viewDetails(item)}
                        title="View Full Details"
                    >
                        <FaEye />
                    </button>
                </div>
            </div>
        );
    };

    const renderListView = () => {
        return (
            <div className="d-flex flex-column gap-3">
                <style>{`
                    .communication-card {
                        border: none;
                        border-radius: 22px;
                        background: #fff;
                        box-shadow: 0 18px 35px rgba(15, 23, 42, 0.08);
                        transition: all 0.3s ease;
                    }
                    .communication-card:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 25px 50px rgba(15, 23, 42, 0.12);
                    }
                    .communication-card__top {
                        display: flex;
                        flex-direction: column;
                        gap: 1rem;
                    }
                    @media (min-width: 768px) {
                        .communication-card__top {
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: flex-start;
                        }
                    }
                    .communication-card__index {
                        width: 48px;
                        height: 48px;
                        border-radius: 14px;
                        background: linear-gradient(135deg, #eef2ff, #e0f2ff);
                        color: #4338ca;
                        font-weight: 700;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }
                    .communication-chip {
                        font-size: 0.75rem;
                        border-radius: 999px;
                        padding: 0.15rem 0.8rem;
                        font-weight: 500;
                    }
                    .communication-card__meta {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
                        gap: 0.75rem;
                        margin: 1rem 0;
                    }
                    .communication-meta-pill {
                        background: #f8fafc;
                        border-radius: 14px;
                        padding: 0.55rem 0.8rem;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        font-size: 0.9rem;
                        color: #475569;
                    }
                    .communication-card__footer {
                        display: flex;
                        flex-direction: column;
                        gap: 0.6rem;
                    }
                    @media (min-width: 768px) {
                        .communication-card__footer {
                            flex-direction: row;
                            align-items: center;
                            justify-content: space-between;
                        }
                    }
                    .message-full {
                        background: #f8f9fa;
                        border-radius: 12px;
                        padding: 1.5rem;
                        margin: 1rem 0;
                        border-left: 4px solid #007bff;
                    }
                    .message-content {
                        font-size: 0.9rem;
                        line-height: 1.5;
                        color: #495057;
                        white-space: pre-wrap;
                        word-wrap: break-word;
                    }
                    .message-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 0.8rem;
                        padding-bottom: 0.5rem;
                        border-bottom: 1px solid #e9ecef;
                    }
                    .message-title {
                        font-weight: 600;
                        color: #343a40;
                        font-size: 0.9rem;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                    }
                `}</style>
                {currentItems.map((item, index) => {
                    const isExpanded = expandedRows.includes(item.id);

                    return (
                        <Card key={item.id} className="communication-card">
                            <Card.Body className="p-4">
                                <div className="communication-card__top">
                                    <div className="d-flex flex-column flex-md-row w-100 justify-content-between align-items-start mb-2 gap-2">

                                    {/* <div className="d-flex align-items-start gap-3 w-100 div_class_change_M1"> */}
                                        <div className="communication-card__index">#{startIndex + index + 1}</div>
                                        <div className="flex-grow-1">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <h5 className="mb-1 fw-semibold text-dark">
                                                        {activeTab === "sms" ? (
                                                            <><FaPhone className="me-2 text-primary" />{item.phone}</>
                                                        ) : (
                                                            <><FaEnvelope className="me-2 text-success" />{item.email}</>
                                                        )}
                                                    </h5>
                                                    <div className="d-flex flex-wrap gap-2 mt-1">
                                                        <Badge bg={item.type === "SMS" ? "primary" : "success"} className="d-flex align-items-center">
                                                            {item.type === "SMS" ? <FaSms className="me-1" /> : <FaEnvelope className="me-1" />}
                                                            {item.type}
                                                        </Badge>
                                                        {item.is_expired && (
                                                            <span className="communication-chip bg-warning-subtle text-warning">
                                                                <FaExclamationTriangle className="me-1" /> Expired
                                                            </span>
                                                        )}

                                                    </div>
                                                </div>
                                                <Badge
                                                    bg={item.status === "sent" ? "success" : "warning"}
                                                    className="px-3 py-2"
                                                    style={{ fontSize: "0.85rem", fontWeight: 600 }}
                                                >
                                                    {item.status === "sent" ? (
                                                        <>
                                                            <FaCheck className="me-1" /> Sent
                                                        </>
                                                    ) : (
                                                        <>
                                                            <FaClock className="me-1" /> Pending
                                                        </>
                                                    )}
                                                </Badge>
                                            </div>

                                            <div className="message-full">
                                                <div className="message-header">
                                                    <span className="message-title">
                                                        <FaFileAlt className="text-info" />
                                                        {activeTab === "sms" ? "SMS Content" : "Email Message"}
                                                    </span>
                                                    <small className="text-muted">
                                                        {item.message_length} characters
                                                    </small>
                                                </div>
                                                <div className="message-content">
                                                    {item.message || "No message content available"}
                                                </div>
                                            </div>

                                            {/* Email Subject (if applicable) */}
                                            {activeTab === "email" && item.subject && (
                                                <div className="communication-meta-pill mt-2">
                                                    <FaFileAlt className="text-primary" />
                                                    <strong>Subject:</strong> {item.subject}
                                                </div>
                                            )}

                                            {/* Meta Information */}
                                            <div className="communication-card__meta">
                                                <div className="communication-meta-pill">
                                                    <FaCalendar className="text-warning" />
                                                    {item.created_at}
                                                </div>
                                                <div className="communication-meta-pill">
                                                    <FaFileAlt className="text-info" />
                                                    {item.message_length} characters
                                                </div>
                                                {activeTab === "sms" && (
                                                    <div className="communication-meta-pill">
                                                        <FaPhone className="text-success" />
                                                        {item.phone}
                                                    </div>
                                                )}
                                                {activeTab === "email" && (
                                                    <div className="communication-meta-pill">
                                                        <FaEnvelope className="text-danger" />
                                                        {item.email}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Footer with Actions */}
                                <div className="communication-card__footer mt-3 pt-3 border-top">
                                    <div className="d-flex align-items-center gap-2">
                                        <small className="text-muted">
                                            <FaClock className="me-1" />
                                            Sent on {item.created_at}
                                        </small>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2 justify-content-start">
                                        {renderCardActions(item)}
                                    </div>
                                </div>

                                {/* Expanded Details - Additional Information */}
                                {isExpanded && (
                                    <div className="mt-3 border-top pt-3">
                                        <Row>
                                            <Col md={6}>
                                                <h6 className="text-muted text-uppercase small mb-3">
                                                    <FaIdCard className="me-2" />
                                                    Message Information
                                                </h6>
                                                <div className="small">
                                                    <div className="mb-2">
                                                        <strong>Type:</strong>
                                                        <Badge bg={item.type === "SMS" ? "primary" : "success"} className="ms-2">
                                                            {item.type}
                                                        </Badge>
                                                    </div>
                                                    <div className="mb-2">
                                                        <strong>ID:</strong> {item.id}
                                                    </div>
                                                    <div className="mb-2">
                                                        <strong>Status:</strong>
                                                        <Badge bg={item.status === "sent" ? "success" : "warning"} className="ms-2">
                                                            {item.status}
                                                        </Badge>
                                                    </div>
                                                    <div className="mb-2">
                                                        <strong>Message Length:</strong> {item.message_length} characters
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <h6 className="text-muted text-uppercase small mb-3">
                                                    <FaFileAlt className="me-2" />
                                                    Technical Details
                                                </h6>
                                                <div className="small">
                                                    <div className="mb-2">
                                                        <strong>Sent Date:</strong> {item.created_at}
                                                    </div>
                                                    <div className="mb-2">
                                                        <strong>Character Count:</strong> {item.message_length}
                                                    </div>
                                                    {item.is_expired && (
                                                        <div className="mb-2">
                                                            <strong>Status:</strong>
                                                            <Badge bg="warning" className="ms-2">
                                                                Expired (30+ days old)
                                                            </Badge>
                                                        </div>
                                                    )}
                                                    {item.message_length > 160 && activeTab === "sms" && (
                                                        <div className="mb-2">
                                                            <strong>Note:</strong>
                                                            <Badge bg="info" className="ms-2">
                                                                Multiple SMS may have been sent
                                                            </Badge>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="page-wrapper">
            <div className="content">
                <Header />

                {/* Summary Cards */}
                <style>{`
                    .summary-scroll {
                        display: flex;
                        gap: 1rem;
                        overflow-x: auto;
                        padding: 0.25rem 0 0.5rem;
                        margin-bottom: 1.5rem;
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                    }
                    .summary-scroll::-webkit-scrollbar {
                        display: none;
                    }
                    .summary-pill {
                        min-width: 230px;
                        border-radius: 1.5rem;
                        padding: 1.25rem;
                        display: flex;
                        align-items: center;
                        gap: 1rem;
                        box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
                    }
                    .summary-pill_icon {
                        width: 48px;
                        height: 48px;
                        border-radius: 1rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 1.4rem;
                        background: #fff;
                    }
                    .summary-pill_value {
                        font-size: 1.75rem;
                        font-weight: 700;
                    }
                    @media (min-width: 1200px) {
                        .summary-scroll {
                            overflow: visible;
                        }
                        .summary-pill {
                            flex: 1;
                        }
                    }
                `}</style>

                {/* Stepper Navigation */}
                <div className="stepper-wrapper mb-4">
                    <div className="stepper d-flex align-items-center">
                        <div
                            className={`step ${activeTab === "sms" ? "active" : ""}`}
                            onClick={() => handleTabClick("sms")}
                            role="button"
                            tabIndex={0}
                        >
                            <FaSms className="step-icon" />
                            <span className="step-label">SMS History</span>
                        </div>
                        <div className="step-connector"></div>
                        <div
                            className={`step ${activeTab === "email" ? "active" : ""}`}
                            onClick={() => handleTabClick("email")}
                            role="button"
                            tabIndex={0}
                        >
                            <FaEnvelope className="step-icon" />
                            <span className="step-label">Email History</span>
                        </div>
                    </div>
                </div>

                {/* Filters Card */}
                <Card className="shadow-sm mb-4">
                    <Card.Header className="bg-white py-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <h5 className="mb-0 d-flex align-items-center">
                                <FaFilter className="me-2 text-primary" />
                                Search {activeTab === "sms" ? "SMS" : "Email"} History
                            </h5>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <Row className="g-3">
                            <Col md={2}>
                                <Form.Label className="fw-semibold">
                                    <FaCalendar className="me-2 text-warning" />
                                    From Date
                                </Form.Label>
                                <FormControl
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold">
                                    <FaCalendar className="me-2 text-warning" />
                                    To Date
                                </Form.Label>
                                <FormControl
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </Col>
                            <Col md={4} className="d-flex align-items-end gap-2">
                                <Button variant="outline-secondary" onClick={resetFilters} className="d-flex align-items-center">
                                    <FaSync className="me-1" /> Reset
                                </Button>
                                <Button variant="primary" onClick={handleSearch} disabled={isLoading} className="d-flex align-items-center">
                                    {isLoading ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-1" /> Loading
                                        </>
                                    ) : (
                                        <>
                                            <FaSearch className="me-1" /> Search
                                        </>
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Results Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="mb-0 d-flex align-items-center">
                        <FaList className="me-2 text-primary" />
                        {activeTab === "sms" ? "SMS History" : "Email History"}
                        <Badge bg="light" text="dark" className="ms-2 fs-6">
                            {totalItems}
                        </Badge>
                    </h5>
                    <div className="text-muted small d-flex align-items-center">
                        <FaEye className="me-1" />
                        Showing {currentItems.length} of {totalItems} records
                    </div>
                </div>

                {/* Loading State */}
                {isLoading && (
                    <Card className="text-center py-5">
                        <Card.Body>
                            <Spinner animation="border" role="status" className="mb-3" variant="primary" />
                            <h5>Loading {activeTab === "sms" ? "SMS" : "Email"} history...</h5>
                            <p className="text-muted">Please wait while we load the records</p>
                        </Card.Body>
                    </Card>
                )}

                {/* Empty State */}
                {!isLoading && currentItems.length === 0 && (
                    <Card className="text-center py-5">
                        <Card.Body>
                            {activeTab === "sms" ? <FaSms size={48} className="text-muted mb-3" /> : <FaEnvelope size={48} className="text-muted mb-3" />}
                            <h5>No {activeTab === "sms" ? "SMS" : "Email"} records found</h5>
                            <p className="text-muted mb-3">Adjust the filters and try again</p>
                            <Button variant="primary" onClick={resetFilters}>
                                <FaSync className="me-1" /> Reset Filters
                            </Button>
                        </Card.Body>
                    </Card>
                )}

                {/* Results */}
                {!isLoading && currentItems.length > 0 && (
                    <>
                        {renderListView()}
                    </>
                )}

                {/* Pagination */}
                {totalItems > itemsPerPage && (
                    <div className="pagination-bar" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", overflowX: "auto", marginTop: "12px" }}>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1 || totalPages === 0}
                        >
                            &lt;
                        </Button>
                        {totalPages > 0 && getVisiblePages(currentPage, totalPages).map((p, idx) =>
                            p === "..."
                                ? <span key={p + idx} style={{ margin: "0 4px", alignSelf: "center" }}>...</span>
                                : (
                                    <Button
                                        key={p}
                                        variant={p === currentPage ? "primary" : "outline-secondary"}
                                        size="sm"
                                        style={{ margin: "0 2px" }}
                                        onClick={() => handlePageChange(p)}
                                    >
                                        {p}
                                    </Button>
                                )
                        )}
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages || totalPages === 0}
                        >
                            &gt;
                        </Button>
                    </div>
                )}
            </div>

            {/* Details Modal */}
            <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="lg" centered>
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title style={{ color: "white" }}>
                        <FaFileAlt className="me-2 text-white" />
                        Communication Details - ID: {selectedRecord?.id}
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    {selectedRecord && (
                        <Row>
                            <Col md={6}>
                                <Card className="h-100">
                                    <Card.Header className="bg-light">
                                        <h6 className="mb-0">
                                            <FaIdCard className="me-2" />
                                            Message Information
                                        </h6>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="detail-grid">
                                            <div className="detail-item">
                                                <strong>Type:</strong>
                                                <Badge bg={selectedRecord.type === "SMS" ? "primary" : "success"} className="ms-2">
                                                    {selectedRecord.type}
                                                </Badge>
                                            </div>
                                            <div className="detail-item">
                                                <strong>ID:</strong> {selectedRecord.id}
                                            </div>
                                            <div className="detail-item">
                                                <strong>Status:</strong>
                                                <Badge bg={selectedRecord.status === "sent" ? "success" : "warning"} className="ms-2">
                                                    {selectedRecord.status}
                                                </Badge>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Message Length:</strong> {selectedRecord.message_length} characters
                                            </div>
                                            <div className="detail-item">
                                                <strong>Sent Date:</strong> {selectedRecord.created_at}
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6}>
                                <Card className="h-100">
                                    <Card.Header className="bg-light">
                                        <h6 className="mb-0">
                                            <FaFileAlt className="me-2" />
                                            {selectedRecord.type === "Email" ? "Email Details" : "SMS Content"}
                                        </h6>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="detail-grid">
                                            {selectedRecord.type === "Email" && (
                                                <div className="detail-item">
                                                    <strong>Subject:</strong>
                                                    <div className="mt-1 p-2 bg-light rounded">
                                                        {selectedRecord.subject}
                                                    </div>
                                                </div>
                                            )}
                                            <div className="detail-item">
                                                <strong>Message:</strong>
                                                <div className="mt-1 p-3 bg-light rounded" style={{ whiteSpace: "pre-wrap", fontSize: "0.85rem" }}>
                                                    {selectedRecord.message}
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <style>{`
                .detail-item {
                    display: flex;
                    align-items: center;
                    padding: 8px 0;
                    border-bottom: 1px solid #f8f9fa;
                }
                .detail-item:last-child {
                    border-bottom: none;
                }
                .detail-grid {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }
                /* Stepper Styles */
                .stepper-wrapper {
                    margin-bottom: 1.5rem;
                }
                .stepper {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.5rem;
                }
                .step {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    cursor: pointer;
                    transition: transform 0.3s ease, color 0.3s ease;
                    padding: 0.5rem;
                    min-width: 120px;
                }
                .step:hover {
                    transform: scale(1.05);
                }
                .step.active {
                    color: #007bff;
                    transform: scale(1.1);
                }
                .step-icon {
                    font-size: 1.5rem;
                    margin-bottom: 0.5rem;
                }
                .step-label {
                    font-size: 0.9rem;
                    font-weight: 500;
                }
                .step-connector {
                    flex-grow: 1;
                    height: 3px;
                    background-color: #e9ecef;
                    margin: 0 0.5rem;
                    position: relative;
                    top: -1.2rem;
                }
                /* Responsive Styles for Stepper */
                @media (max-width: 768px) {
                    .stepper {
                        flex-direction: row;
                        gap: 0.25rem;
                        justify-content: center;
                        flex-wrap: nowrap;
                    }
                    .step {
                        min-width: 80px;
                        padding: 0.25rem;
                    }
                    .step-icon {
                        font-size: 1rem;
                    }
                    .step-label {
                        font-size: 0.7rem;
                    }
                    .step-connector {
                        height: 2px;
                        margin: 0 0.25rem;
                        top: -1rem;
                    }
                }
            `}</style>
        </div>
    );
}


export default ResendPasswordHistory